import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { httpClient } from 'src/utils/HttpClients';
import { AppContext } from 'src/context';
import type { TCreateNotice } from 'src/types';

export const useCreateNotice = () => {
    const {
        actions: { handleCallNotification },
    } = useContext(AppContext);
    const queryClient = useQueryClient();
    const mutationFn = async (payload: TCreateNotice) => {
        const { data } = await httpClient.post(`/notices`, {
            ...payload,
            location_id: payload.location_id ? payload.location_id : null,
        });
        return data;
    };

    const onSuccess = () => {
        handleCallNotification({ message: 'The notice has been created successfully.' });
    };

    const onSettled = async () => {
        await queryClient.invalidateQueries(['notices']);
    };

    return useMutation(mutationFn, {
        onSettled,
        onSuccess,
    });
};
